import { Button, Dialog, DialogCustomContent, Label } from '@playcastdotio/Shadcn';
import pcLogo from '../../../assets/playcast_logo-96x96.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';
import { Account, Preferences, Privacy } from '@playcastdotio/Settings';
import constants from '@playcastdotio/GlobalConfig';
import { PlaycastContext } from '../PlaycastWrapper';
import { NotificationTypes } from '@playcastdotio/Settings';

type NavItem = {
  title: string;
  component: React.ReactNode;
};

export const SettingsModal = ({ state }: { state: [boolean, Dispatch<SetStateAction<boolean>>] }) => {
  const context = useContext(PlaycastContext);
  const [allowPeerConnections, setInternalAllowPeerConnections] = useState(context.stateStores.iceServerState.allowPeerConnections);
  const setAllowPeerConnections = (allowPeerConnections: boolean) => {
    context.targetFunctions.setAllowPeerConnections(allowPeerConnections);
    setInternalAllowPeerConnections(allowPeerConnections);
  };
  useEffect(() => {
    setInternalAllowPeerConnections(context.stateStores.iceServerState.allowPeerConnections);
  }, [context.stateStores.iceServerState.allowPeerConnections]);
  const [activeNav, setActiveNav] = useState(0);
  const [show, setShow] = state;
  const [nav, setNav] = useState<NavItem[]>([
    {
      title: 'Account',
      component: <div></div>,
    },
    {
      title: 'Privacy & Security',
      component: (
        <Privacy
          allowPeerConnections={allowPeerConnections}
          setAllowPeerConnections={setAllowPeerConnections}
          edition={context.stateStores.hostState.edition ?? 'standard'}
        />
      ),
    },
    {
      title: 'Preferences',
      component: <div></div>,
    },
  ]);

  const onEditEmail = (newEmail: string) => {
    console.log('Edit email', newEmail);
  };
  const onEditPhoneNumber = (newPhoneNumber: string) => {
    console.log('Edit phone number', newPhoneNumber);
  };

  const savePreferences = (phonePreferences: NotificationTypes, emailPreferences: NotificationTypes) => {
    if (context.remoteControlFunctions) context.remoteControlFunctions.savePreferences(phonePreferences, emailPreferences);
    else if (context.electronFunctions) context.electronFunctions.savePreferences(phonePreferences, emailPreferences);
  };

  useEffect(() => {
    const email = context.stateStores.loginProfileState.email ?? '';
    const phoneNumber =
      (context.stateStores.loginProfileState.phoneNumber ?? context.stateStores.loginProfileState.name.startsWith('+'))
        ? context.stateStores.loginProfileState.name
        : '';
    const initialPreferences = context.stateStores.preferenceState;

    setNav([
      {
        title: 'Account',
        component: <Account email={email} phoneNumber={phoneNumber} onEditEmail={onEditEmail} onEditPhoneNumber={onEditPhoneNumber} />,
      },
      {
        title: 'Privacy & Security',
        component: (
          <Privacy
            allowPeerConnections={allowPeerConnections}
            setAllowPeerConnections={setAllowPeerConnections}
            edition={context.stateStores.hostState.edition ?? 'standard'}
          />
        ),
      },
      {
        title: 'Preferences',
        component: <Preferences savePreferences={savePreferences} initialPreferences={initialPreferences} />,
      },
    ]);
  }, [
    context.stateStores.loginProfileState.email,
    context.stateStores.loginProfileState.name,
    context.stateStores.loginProfileState.phoneNumber,
    context.stateStores.iceServerState.allowPeerConnections,
  ]);

  const handleClose = () => {
    setShow(false);
  };

  return (
    <Dialog open={show}>
      <DialogCustomContent className='max-w-3xl gap-0 border-none bg-gray-800'>
        <div className='bg-midnight z-50 flex w-full items-center rounded-t-lg shadow-sm'>
          <div className='title-bar ml-4 flex shrink-0 items-center gap-x-2'>
            <img src={pcLogo} alt='Logo' className='h-7 w-7' />
            <h1 className='text-md font-headline font-semibold text-white'>Account Settings</h1>
          </div>
          <div className='flex-grow' />
          <Button
            size='icon'
            variant='ghost'
            className='h-10 w-9 rounded-t-lg text-gray-300 hover:bg-inherit hover:text-white'
            onClick={handleClose}
          >
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </div>
        <div className='flex h-[30rem]'>
          <nav className='flex flex-col bg-gray-800'>
            {nav.map((item, index) => (
              <div className='px-2' key={item.title}>
                <button
                  key={index}
                  className='flex items-center gap-x-4 px-4 py-3 text-white hover:text-gray-400'
                  onClick={() => setActiveNav(index)}
                >
                  <span className='truncate font-light'>{item.title}</span>
                </button>
                <div className='border-b border-gray-600' />
              </div>
            ))}
            <div className='flex-1' />
            <Label className='p-2 text-sm text-gray-600'>{constants.VERSION}</Label>
          </nav>
          <div className='flex w-full overflow-y-auto bg-gray-900 p-4'>{nav[activeNav].component}</div>
        </div>
      </DialogCustomContent>
    </Dialog>
  );
};
